const newsList = [
    {
      title: 'VIRSAT Brings New Virtual Reality Training',
      slug:'virsat-brings-new-virtual-reality-training-adipec-2022'
    },
  ]
  
  export default newsList;